import React, { useState, useRef, useEffect } from "react";
import "../Bfsi Solution/faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const answerRefs = useRef([]);

  const faqs = [
    {
      q: "What Services Does Your E-commerce Website Development Company Offer?",
      a: "We provide end-to-end e-commerce website development services, including custom website design, development, payment gateway integration, and ongoing maintenance.",
    },
    {
      q: "How Do I Get Started With Building My E-commerce Website?",
      a: "Getting started is easy. Contact us through our website or email, and our team will guide you through the initial consultation, where we discuss your requirements, goals, and preferences.",
    },
    {
      q: "Can You Design a Custom E-commerce Website Tailored to My Brand?",
      a: "Absolutely. Our team specializes in creating custom e-commerce websites that align with your brand identity, goals, and user experience requirements.",
    },
    {
      q: "What E-commerce Platforms Do You Work With?",
      a: "We work with a variety of e-commerce platforms, including but not limited to Shopify, WooCommerce, Magento, and custom-built solutions. We choose the platform based on your specific needs.",
    },
    {
      q: "How Long Does It Take to Develop an E-commerce Website?",
      a: "The timeline for e-commerce website development varies based on the complexity and features required. We provide detailed project timelines during the consultation phase.",
    },
    {
      q: "Can You Integrate Third-party Payment Gateways Into the E-commerce Website?",
      a: "Yes, we can integrate a wide range of third-party payment gateways to facilitate secure and convenient online transactions for your customers.",
    },
    {
      q: "Is Seo Included in Your E-commerce Website Development Services?",
      a: "Yes, SEO considerations are an integral part of our e-commerce website development process. We implement SEO best practices to optimize your website for search engines.",
    },
    {
      q: "How Do You Ensure the Security of E-commerce Websites You Develop?",
      a: "We prioritize security by implementing SSL encryption, secure payment gateways, and following industry best practices. Regular security audits are conducted to identify and address vulnerabilities.",
    },
    {
      q: "Can You Migrate My Existing E-commerce Website to a New Platform?",
      a: "Yes, we offer e-commerce website migration services to seamlessly transition your website to a new platform while preserving data integrity and functionality.",
    },
    {
      q: "What Ongoing Support and Maintenance Services Do You Provide?",
      a: "We offer comprehensive support and maintenance services to address any issues, update features, and ensure the continued smooth operation of your e-commerce website.",
    },
    {
      q: "How Do You Ensure the E-commerce Website is Mobile-responsive?",
      a: "All the e-commerce websites we develop are designed to be fully responsive, ensuring optimal performance and user experience across various devices and screen sizes.",
    },
    {
      q: "Can I See Examples of E-commerce Websites You Have Developed?",
      a: "Certainly. We can provide you with a portfolio of our previous e-commerce website projects during our initial consultation.",
    },
  ];

  const toggleFaq = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  // Get height for smooth animation
  const getHeight = (index) => {
  const el = answerRefs.current[index];
  if (!el) return "0px";

  const padding = 40; // top 20 + bottom 20
  return `${el.scrollHeight + padding}px`;
};


  return (
    <div className="faq-wrapper">
      <h2 className="faq-title">Faq's</h2>

      {faqs.map((item, index) => (
        <div
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
          key={index}
        >
          <div className="faq-question" onClick={() => toggleFaq(index)}>
            <span>{item.q}</span>
            <span className="faq-icon">
              {activeIndex === index ? "−" : "+"}
            </span>
          </div>

          {/* Smooth answer */}
          <div
            className="faq-answer"
            ref={(el) => (answerRefs.current[index] = el)}
            style={{
              maxHeight: activeIndex === index ? getHeight(index) : "0px",
            }}
          >
            <p>{item.a}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
